import { useMenu as r } from "../../hooks/useMenu.js";
import { idsLogger as i } from "../../../../helpers/utility/idsLogger.js";
const c = ({
  selected: t,
  value: o
}) => {
  const e = r(), s = e != null && e.supportsSelection ? e.isSelected(o) : t;
  return e != null && e.supportsSelection && t && i(
    "IressMenuItem: The selected prop on IressMenuItem does not work when used inside an IressMenu with role=listbox or the multiSelect prop set to true. Use the selected prop on IressMenu instead."
  ), {
    "aria-selected": e != null && e.supportsSelection ? s : void 0,
    "aria-current": (e == null ? void 0 : e.role) === "nav" || e != null && e.nav ? s : void 0
  };
};
export {
  c as useMenuItemAria
};
